"use client";
import { Button } from "@/components/ui/button";
import { guideDoneKey, useStoredValue, writeStoredValue } from "../../hooks";

interface GuideDoneButtonProps {
  progressId: string;
  label: string;
  doneLabel: string;
}

// "Mark this guide as done" - a toggle saved in this browser only. The
// /guides hub reads the same flag for its progress bar and "Done" badges.
const GuideDoneButton = ({ progressId, label, doneLabel }: GuideDoneButtonProps) => {
  const key = guideDoneKey(progressId);
  const isDone = useStoredValue(key) === "1";
  return (
    <Button
      type="button"
      aria-pressed={isDone}
      variant={isDone ? "brand" : "brandOutline"}
      size="pill"
      onClick={() => writeStoredValue(key, isDone ? "0" : "1")}
      className="mt-4"
    >
      {isDone ? doneLabel : label}
    </Button>
  );
};

export default GuideDoneButton;
